<template>
  <div class="theme-page" style="padding: 32px;">
    <h2>Element UI 主题色测试</h2>
    <div style="margin-bottom: 24px;">
      <el-button type="default">默认</el-button>
      <el-button type="primary">主按钮</el-button>
      <el-button type="success">成功</el-button>
      <el-button type="warning">警告</el-button>
      <el-button type="danger">危险</el-button>
      <el-button type="info">信息</el-button>
    </div>
    <div style="margin-bottom: 24px;">
      <el-input v-model="value1" placeholder="测试输入框" style="width: 240px;" />
      <el-select v-model="value2" placeholder="测试下拉" style="width: 180px; margin-left: 16px;">
        <el-option label="选项一" value="1" />
        <el-option label="选项二" value="2" />
      </el-select>
    </div>
    <div style="margin-bottom: 24px;">
      <el-alert title="主题色警告" type="warning" show-icon />
      <el-alert title="主题色成功" type="success" show-icon style="margin-top: 8px;" />
    </div>
    <div>
      <el-tag type="primary">Primary</el-tag>
      <el-tag type="success">Success</el-tag>
      <el-tag type="warning">Warning</el-tag>
      <el-tag type="danger">Danger</el-tag>
      <el-tag type="info">Info</el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThemePage",
  data() {
    return {
      value1: "1", // 下拉框默认值
      value2: "1" // 另一个下拉框默认值
    };
  }
};
</script>